import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard, Autoplay, Thumbs, FreeMode, Mousewheel } from 'swiper/modules';

export default function testimonialsSlider() {

  const testimonialsConfig = {
    modules: [Navigation, Pagination, Keyboard, Autoplay],
    // direction: 'vertical',
    // loop: true,
    slidesPerView: 1,
    spaceBetween: 25,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    autoplay: {
      delay: 3000,
      pauseOnMouseEnter: true
    },
    breakpoints: {
      // when window width is >= 768px
      768: {
        slidesPerView: 2,
        spaceBetween: 25
      },
      // when window width is >= 1224px
      1224: {
        slidesPerView: 3,
        spaceBetween: 25
      }
    },
    pagination: {
      el: '.testimonials .swiper-pagination',
    },
    navigation: {
      nextEl: '.testimonials .unm-slider-btn-next',
      prevEl: '.testimonials .unm-slider-btn-prev',
    },
  }

  if (document.querySelector('.testimonials[data-module="slider"]')) {
    const testimonialsSwiper = new Swiper('.testimonials[data-module="slider"] .swiper', testimonialsConfig);
    return testimonialsSwiper
  }
  return
}